export default [
  {
    path: "/estadisticas/ofertas",
    component: () => import("@/views/estadisticas/Ofertas.vue"),
  },
  {
    path: "/estadisticas/ofertasEntregadas",
    component: () => import("@/views/estadisticas/OfertasEntregadas.vue"),
  },
  {
    path: "/estadisticas/modulos",
    component: () => import("@/views/estadisticas/Modulos.vue"),
  },
];
